import { FIELD_TYPE_LOADING, FIELD_TYPE_TRAER_TODAS } from "../../types";

const FieldTypeReducer = (state, action) => {
  switch (action.type) {
    case FIELD_TYPE_LOADING:
      return {...state, loading:true, error:null}
    case FIELD_TYPE_TRAER_TODAS:
      return {...state, loading:false, error:null, data:action.payload}
    default:
      return state;
  }
}

export default FieldTypeReducer;